import React, { useState } from "react";
import { toast } from "sonner";
import { Loader2, CheckCircle2 } from "lucide-react";
import LegalPageLayout from "../components/LegalPageLayout";
import { api, errMsg } from "../lib/api";

const inputCls = "w-full h-11 px-3.5 rounded-lg bg-slate-50 border border-slate-200 text-sm text-slate-800 outline-none focus:border-sky-400";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", topic: "general", message: "" });
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.submitContact(form); setSent(true); } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <LegalPageLayout badge="Contact" title="Talk to us." subtitle="Questions about billing, a bug, or an idea? We reply within one business day. You can also email support@ishukart.org.">
      <div className="rounded-2xl border border-slate-200/80 bg-white p-6 sm:p-8">
        {sent ? (
          <div className="flex items-center gap-3 text-emerald-700" data-testid="contact-success"><CheckCircle2 /> Thanks — your message is in. We'll get back to you soon.</div>
        ) : (
          <form onSubmit={submit} className="grid sm:grid-cols-2 gap-4" data-testid="contact-form">
            <input required minLength={2} value={form.name} onChange={set("name")} placeholder="Your name" className={inputCls} data-testid="contact-name-input" />
            <input required type="email" value={form.email} onChange={set("email")} placeholder="you@example.com" className={inputCls} data-testid="contact-email-input" />
            <select value={form.topic} onChange={set("topic")} className={`${inputCls} sm:col-span-2`} data-testid="contact-topic-select">
              <option value="general">General question</option>
              <option value="billing">Billing & credits</option>
              <option value="bug">Report a problem</option>
              <option value="feedback">Feedback</option>
            </select>
            <textarea required minLength={10} rows={5} value={form.message} onChange={set("message")} placeholder="How can we help?" data-testid="contact-message-input"
              className="sm:col-span-2 w-full px-3.5 py-3 rounded-lg bg-slate-50 border border-slate-200 text-sm text-slate-800 outline-none focus:border-sky-400" />
            <button type="submit" disabled={busy} data-testid="contact-submit-btn" className="w-fit h-11 px-6 rounded-lg bg-slate-900 text-white text-sm font-semibold hover:bg-slate-700 flex items-center gap-2">
              {busy && <Loader2 size={15} className="animate-spin" />} Send message
            </button>
          </form>
        )}
      </div>
    </LegalPageLayout>
  );
}
